import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SupabaseService } from './supabase.service';

export const authGuard: CanActivateFn = async () => {
  const supabase = inject(SupabaseService);
  const router = inject(Router);
  if (!supabase.configured) return router.createUrlTree(['/login']);
  const { data: { session } } = await supabase.client.auth.getSession();
  return session ? true : router.createUrlTree(['/login']);
};

export const loginGuard: CanActivateFn = async () => {
  const supabase = inject(SupabaseService);
  const router = inject(Router);
  if (!supabase.configured) return true;
  const { data: { session } } = await supabase.client.auth.getSession();
  return session ? router.createUrlTree(['/dashboard']) : true;
};
